import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {TenantService} from './tenant.service';
import {PricingPlan} from '../models/pricing-plan.model';
import {Observable} from 'rxjs';
import {StripeSession} from './stripe-session';


@Injectable({
  providedIn: 'root'
})
export class PaymentsService {

  constructor(
    private http: HttpClient,
    private tenant: TenantService) {

  }

  createPurchaseCourseSession(courseId:string, courseUrl:string, couponCode:string): Observable<StripeSession> {
    return this.http.post<StripeSession>(
      environment.api.purchaseCourseUrl,
      {
        courseId,
        courseUrl,
        tenantId: this.tenant.id,
        couponCode
      });
  }

  createPurchaseBundleSession(bundleCode:string): Observable<StripeSession> {
    return this.http.post<StripeSession>(
      environment.api.purchaseBundleUrl,
      {
        bundleCode,
        tenantId: this.tenant.id,
        baseUrl: `${window.location.protocol}//${window.location.host}`
      });

  }

  createActivatePlanSession(plan: PricingPlan, quantity:number, oneTimeCharge: boolean, subscriptionUrl:string,
                            isTeamPlan:boolean, couponCode?:string): Observable<StripeSession> {
    return this.http.post<StripeSession>(
      environment.api.stripeActivatePlanUrl,
      {
        plan,
        quantity,
        subscriptionUrl,
        tenantId: this.tenant.id,
        oneTimeCharge,
        isTeamPlan,
        couponCode
      });
  }

  createUpdateCardSession(userSettingsUrl:string, stripeCustomerId): Observable<StripeSession> {
    return this.http.post<StripeSession>(
      environment.api.stripeUpdateCardUrl,
      {
        userSettingsUrl,
        stripeCustomerId,
        tenantId: this.tenant.id
      });
  }

  cancelPlan(email:string, displayName: string, reason: string, targetUserId:string = null): Observable<any> {
    return this.http.post(
      environment.api.stripeCancelPlanUrl,
      {
        email,
        displayName,
        tenantId: this.tenant.id,
        reason,
        targetUserId
      }
    );
  }

  createUpdateCommunityPlans(params: any): Observable<any> {
    return this.http.post(environment.api.stripeCreateUpdateCommunityPlansUrl, {
      tenantId: params.tenantId,
      benefits: params.benefits,
      monthlyPlanPrice: params.monthlyPlanPrice,
      yearlyPlanPrice: params.yearlyPlanPrice,
      testUser: params.testUser,
    });
  }

  activateCommunityPlan(params: any): Observable<any> {
    return this.http.post(environment.api.stripeActivateCommunityPlanUrl, {
      plan: params.plan,
      quantity: params.quantity,
      subscriptionUrl: params.subscriptionUrl,
      tenantId: params.tenantId,
      testUser: params.testUser,
      sessionLanguage: params.sessionLanguage
    });
  }

  createUpdateRoomPlans(params: any): Observable<any> {
    return this.http.post(environment.api.stripeCreateUpdateRoomPlansUrl, {
      tenantId: params.tenantId,
      roomId: params.roomId,
      currency: params.currency,
      benefits: params.benefits,
      monthlyPlanPrice: params.monthlyPlanPrice,
      yearlyPlanPrice: params.yearlyPlanPrice,
      testUser: params.testUser,
    });
  }

  activateRoomPlan(params: any): Observable<any> {
    return this.http.post(environment.api.stripeActivateRoomPlanUrl, {
      plan: params.plan,
      roomId: params.roomId,
      quantity: params.quantity,
      subscriptionUrl: params.subscriptionUrl,
      tenantId: params.tenantId,
      testUser: params.testUser,
      sessionLanguage: params.sessionLanguage
    });
  }

  cancelCommunityRoomPlan(params: any): Observable<any> {
    return this.http.post(environment.api.stripeCancelCommunityRoomPlanUrl,
      {
        planToCancel: params.planToCancel,
        roomId: params.roomId,
        email: params.email,
        displayName: params.displayName,
        tenantId: params.tenantId,
        reason: params.reason,
        testUser: params.testUser,
        targetUserId: params.targetUserId
      }
    );
  }
}
